import VehicleForm from './VehicleForm';

export default VehicleForm;
